module.exports = __webpack_public_path__ + "static/img/bj14.553c827.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/auditing/images/bj14.png
// module id = Rtj8
// module chunks = 0